import axios from "axios";
import { supabase } from "./initSupabase";


axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.defaults.headers.common = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

axios.interceptors.request.use(
  async (config: any) => {
    const session = (await supabase.auth.getSession())?.data?.session;
    if (session) {
      config.headers.Authorization = `Bearer ${session?.access_token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// axios.interceptors.response.use(
//   (response: any) => {
//     return { data: response.data, headers: response.headers };
//   },
//   (err) => {
//     // if (err.response.status === 401) {
//     //   window.localStorage.clear();
//     //   window.location = "/";
//     // }

//     // if (err.response.status == 403) {
//     //   switch (err.response.data.message) {
//     //     case "Your email address is not verified.":
//     //       history.push("/not-verified");
//     //       break;
//     //     case "select_account":
//     //       history.push("/choose-team");
//     //       break;
//     //     case "no_accounts":
//     //       history.push("/create-team");
//     //       break;
//     //     default:
//     //       break;
//     //   }
//     // }

//     if (err.response.status == 404) {
//       history.push("/e/404");
//     }

//     if (err.response.status == 503) {
//       history.push("/e/503");
//     }

//     if (err.response.status == 429) {
//       history.push("/e/429");
//     }

//     return Promise.reject(err);
//   }
// );

export default axios;
